import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['filename', 'input'];

  change() {
    const [file] = this.inputTarget.files;

    this.filenameTarget.textContent = file ? file.name : '';
  }
}
